require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./masala-dabba-100-musthaveindiandishestospiceupyourlife.json") })
        }
      }, "path---masala-dabba-100-musthaveindiandishestospiceupyourlife");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---masala-dabba-100-musthaveindiandishestospiceupyourlife!./.cache/json/masala-dabba-100-musthaveindiandishestospiceupyourlife.json
// module id = 718
// module chunks = 231608221292675